"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SYNC_RECONNECT_HINT = void 0;
exports.syncOutcomeCopy = syncOutcomeCopy;
// FP-175 (2026-10-08, wording agreed with mobile): a bank can now be marked "Connection
// ended" (Connect again), not only "Reconnect", so the hint names neither label alone.
exports.SYNC_RECONNECT_HINT = "Any bank marked below needs your attention. Reconnect it or connect it again; otherwise, try again later.";
function syncOutcomeCopy(counts) {
    const { banksSynced, banksTotal } = counts;
    const added = counts.transactionsAdded;
    const changes = `${added} new ${added === 1 ? "transaction" : "transactions"}, ${counts.transactionsModified} updated.`;
    if (banksSynced >= banksTotal)
        return { title: "Sync Complete", body: changes };
    if (banksSynced === 0) {
        return {
            title: "Couldn't sync",
            body: banksTotal === 1
                ? `Your bank couldn't sync. ${exports.SYNC_RECONNECT_HINT}`
                : `None of your banks could sync. ${exports.SYNC_RECONNECT_HINT}`,
        };
    }
    return {
        title: "Couldn't sync every bank",
        body: `${banksSynced} of ${banksTotal} banks synced: ${changes} ${exports.SYNC_RECONNECT_HINT}`,
    };
}
//# sourceMappingURL=syncOutcomeCopy.js.map